import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(localStorage.getItem("hop_workspace_id"));
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setWorkspaces(data.workspaces || []);
      if (!workspaceId && data.workspaces?.[0]) {
        setWorkspaceId(data.workspaces[0].id);
        localStorage.setItem("hop_workspace_id", data.workspaces[0].id);
      }
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("hop_token")) refresh();
    else setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hop_token", data.token);
    if (data.user?.default_workspace_id) {
      localStorage.setItem("hop_workspace_id", data.user.default_workspace_id);
      setWorkspaceId(data.user.default_workspace_id);
    }
    await refresh();
  };

  const register = async (email, name, password, workspace_name) => {
    const { data } = await api.post("/auth/register", { email, name, password, workspace_name });
    localStorage.setItem("hop_token", data.token);
    localStorage.setItem("hop_workspace_id", data.workspace.id);
    setWorkspaceId(data.workspace.id);
    await refresh();
  };

  const logout = () => {
    localStorage.removeItem("hop_token");
    localStorage.removeItem("hop_workspace_id");
    setUser(null);
    setWorkspaces([]);
    setWorkspaceId(null);
    window.location.href = "/login";
  };

  const switchWorkspace = (id) => {
    localStorage.setItem("hop_workspace_id", id);
    setWorkspaceId(id);
    window.location.reload();
  };

  const currentWorkspace = workspaces.find((w) => w.id === workspaceId);
  const role = currentWorkspace?.role || "founder";

  return (
    <AuthCtx.Provider value={{ user, workspaces, workspaceId, currentWorkspace, role, loading, login, register, logout, refresh, switchWorkspace }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
